import { Image } from "@chakra-ui/image";
import { Flex } from "@chakra-ui/layout";

function Sidebar({
  img,
  children,
  imgMt = "-60px",
  bg = "white",
  maxH,
}: {
  img?: any;
  imgMt?: number | string;
  children?: React.ReactChild | null;
  bg?: string;
  maxH?: number | string;
}) {
  return (
    <Flex flexDir="column" maxH={maxH} overflowY={maxH ? "auto" : undefined}>
      {img ? (
        <Flex px="32px" justifyContent="center">
          <Image mt={imgMt} w="100%" src={img} />
        </Flex>
      ) : null}
      {children ? (
        <Flex
          flexDir="column"
          p="16px"
          rounded="16px"
          mt="-32px"
          flex={1}
          bg={bg}
        >
          {children}
        </Flex>
      ) : null}
    </Flex>
  );
}

export default Sidebar;
